export default __webpack_public_path__ + "static/media/logo.8c6b23c2.png";